/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum DeviceDataKey {
  /**
   * Describes the type of platform
   */
  PLATFORM_TYPE = 'platform_type',
  /**
   * Manufacturer of the user's device
   */
  CUSTOM_DEVICE_MANUFACTURER = 'custom_device_mfg',
  /**
   * Name of the device model used by the viewer
   */
  CUSTOM_DEVICE_NAME = 'custom_device_name',
  /**
   * New Relic deviceID
   */
  QP_GLOBAL_ID = 'qp_global_id',
  /**
   * A unique identifier for the platform sending the data
   */
  PLATFORM_NAME = 'platform_name',

  /**
   * Brand of the device
   */
  BRAND = 'device_brand',
  /**
   * Category of the device (e.g., mobile, tablet, desktop)
   */
  CATEGORY = 'device_category',
  /**
   * Model of the device
   */
  MODEL = 'device_model',
  /**
   * Name of the operating system
   */
  OS_NAME = 'operating_system_name',
  /**
   * Version of the operating system
   */
  OS_VERSION = 'operating_system_version',
  /**
   * Height of the device screen in pixels
   */
  SCREEN_RESOLUTION_HEIGHT = 'screen_height',
  /**
   * Scale factor of the device screen
   */
  SCREEN_RESOLUTION_SCALE_FACTOR = 'scale_factor',
  /**
   * Width of the device screen in pixels
   */
  SCREEN_RESOLUTION_WIDTH = 'screen_width',
  /**
   * Type of the device (e.g., phone, tablet, TV)
   */
  TYPE = 'device_type',
  /**
   * Version of the device
   */
  VERSION = 'device_version',

  /**
   * Manufacturer of the device
   */
  DEVICE_MANUFACTURER = 'device_manufacturer',

  /**
   * Capability of the device (e.g., HIGH, MEDIUM, LOW)
   */
  DEVICE_CAPABILITY = 'device_capability',

  /**
   * Name of the device model used by the viewer
   */
  DEVICE_NAME = 'device',

  /**
   * Device group (e.g., Connected TV, Mobile, Tablet, Desktop)
   */
  DEVICE_GROUP = 'device_group',

  /**
   * Firstlight - generated unique device identifier.
   */
  DEVICE_ID = 'device_id',
}
